import { formatCurrency } from './formatters.js';

// Header banner promise, built from what checkout actually offers
// (settings.fulfillment from the public settings API), so the banner can
// never advertise free or Canada-wide delivery the shop doesn't provide.
export function headerBannerText(fulfillment) {
  const f = fulfillment || {};
  const parts = [];
  if (f.deliveryEnabled) {
    if (f.deliveryAlwaysFree) {
      parts.push(f.deliveryCanadaWide ? 'Free delivery across Canada' : 'Free delivery');
    } else if (f.freeDeliveryThresholdCents != null) {
      parts.push(`Free delivery on orders over ${formatCurrency(f.freeDeliveryThresholdCents / 100)}`);
    } else {
      parts.push(f.deliveryCanadaWide ? 'Canada-wide delivery' : 'Delivery available');
    }
  }
  if (f.pickupEnabled) parts.push('Free in-store pickup');
  parts.push('Authorized resellers');
  return parts.join(' · ');
}
